import github from "../assets/github.png"
import html from "../assets/html.png"
import css from "../assets/css.png"
import javascript from "../assets/javascript.png"
import nodejs from "../assets/node.png"
import reactjs from "../assets/react.png"
import tailwind from "../assets/tailwind.png"
import mongodb from "../assets/mongodb.png"
import express from "../assets/express.png"

const experienceDetails = [
    {
        id:1,
        srcs:html,
        title:"HTML",
        style:"shadow-orange-400"
    },

    {
        id:2,
        srcs:css,
        title:"CSS",
        style:"shadow-blue-400"
    },

    {
        id:3,
        srcs:javascript,
        title:"JavaScript",
        style:"shadow-yellow-400"
    },

    {
        id:4,
        srcs:reactjs,
        title:"ReactJS",
        style:"shadow-cyan-400"
    },

    {
        id:5,
        srcs:nodejs,
        title:"Node.js",
        style:"shadow-lime-400"
    },

    {
        id:6,
        srcs:tailwind,
        title:"Tailwind",
        style:"shadow-cyan-200"
    },

    {
        id:7,
        srcs:github,
        title:"Github",
        style:"shadow-gray-400"
    },

    {
        id:8,
        srcs:mongodb,
        title:"MongoDB",
        style:"shadow-green-800"
    },

    {
        id:9,
        srcs:express,
        title:"ExpressJS",
        style:"shadow-neutral-100"
    }
];

export default experienceDetails;